// Widget definitions and configurations
export const AVAILABLE_WIDGETS = [
  {
    id: "heatmap",
    title: "Controls Posture Heatmap",
    w: 12,
    h: 5.7,
    minH: 5.7,
    minW: 6,
    static: false,
    contentType: "component",
    componentType: "OperationalHeatmap",
    description:
      "Posture across security domains and infrastructure pillars. Highlights where controls are applied and missing.",
    chartType: "heatmap",
  },
  {
    id: "securityScore",
    title: "Security Score",
    w: 12,
    h: 3.5,
    minH: 3.5,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "SecurityScoreWidget",
    description:
      "Overall security posture and trend, based on Posture Heatmap.",
    chartType: "two-line",
  },
  {
    id: "securityDomainScore",
    title: "Security Domain Score",
    w: 12,
    h: 2.5,
    minH: 2.5,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "SecurityDomainScoreWidget",
    description: "Aggregated posture score across core security domains.",
    chartType: "gauge",
  },
  {
    id: "infrastructurePillarsScore",
    title: "Infrastructure Pillars Score",
    w: 12,
    h: 2.5,
    minH: 2.5,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "InfrastructurePillarsScoreWidget",
    description: "Aggregated posture score across infrastructure layers.",
    chartType: "gauge",
  },

  {
    id: "toolsPerformance",
    title: "Security Controls Efficiency",
    w: 12,
    h: 3,
    minH: 3,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "ToolsPerformanceTrendWidget",
    description: "How many controls are compliant.",
    chartType: "gauge",
  },

  {
    id: "topOpenGaps",
    title: "Top Open Gaps",
    w: 12,
    h: 3.3,
    minH: 3.3,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "TopOpenGaps",
    description:
      "Most critical unresolved gaps, prioritized by severity and impacted assets.",
    chartType: "table",
  },
  {
    id: "teamTasks",
    title: "Team Tasks",
    w: 12,
    h: 3.75,
    minH: 3.75,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "TeamTasks",
    description: "Tasks assigned to team members, sorted by severity.",
    chartType: "table",
  },
  {
    id: "myTasks",
    title: "My Tasks",
    w: 12,
    h: 3.75,
    minH: 3.75,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "MyTasks",
    description: "Tasks assigned to you, sorted by severity.",
    chartType: "table",
  },
  {
    id: "myFavoriteControls",
    title: "My Favorite Controls",
    w: 12,
    h: 3.75,
    minH: 3.75,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "FavoriteControls",
    description:
      "Controls you’ve marked as favorites for quick tracking, sorted by severity.",
    chartType: "table",
  },
  {
    id: "toolCoverage",
    title: "Tool Coverage",
    w: 12,
    h: 4,
    minH: 4,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "ToolCoverageWidget",
    description: "Coverage and trend of selected tools across your stack.",
    chartType: "bar",
  },
  {
    id: "inventory",
    title: "Inventory",
    w: 12,
    h: 3.25,
    minH: 3.25,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "InventoryWidget",
    description: "Entities distribution and coverage across entity types.",
    chartType: "donut",
  },

  {
    id: "criticalAssets",
    title: "Critical Assets",
    w: 12,
    h: 3.25,
    minH: 3.25,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "CriticalAssetPieWidget",
    description:
      "Critical assets distribution and coverage across asset types.",
    chartType: "donut",
  },
  {
    id: "openGapsAge",
    title: "Open Gaps Age",
    w: 12,
    h: 1.65,
    minH: 1.65,
    minW: 12,
    static: false,
    contentType: "component",
    componentType: "OpenGapsAgeWidget",
    description:
      "Shows average and longest time gaps remain open across the environment.",
    chartType: "metrics",
  },

  // TODO: Uncomment after we collect more activity logs
  // {
  //   id: "toolsRemediationPerformance",
  //   title: "Remediation Performance Across Tools",
  //   w: 12,
  //   h: 4,
  //   minH: 4,
  //   minW: 12,
  //   static: false,
  //   contentType: "component",
  //   componentType: "ToolsRemediationPerformanceWidget",
  //   description:
  //     "Entities affected by remediation efforts .",
  //   chartType: "bar",
  // },
  // {
  //   id: "teamRemediationPerformance",
  //   title: "Team Remediation Performance",
  //   w: 12,
  //   h: 4,
  //   minH: 4,
  //   minW: 12,
  //   static: false,
  //   contentType: "component",
  //   componentType: "TeamRemediationPerformanceWidget",
  //   description:
  //     "Entities affected by remediation efforts per team member.",
  //   chartType: "bar",
  // },
];

// used in demo and enabled by an env feature flag
const POSTURE_TREND_WIDGET_DEFINITION = {
  id: "postureTrend",
  title: "Posture Trend Over Time",
  w: 12,
  h: 4,
  minH: 4,
  minW: 12,
  static: false,
  contentType: "component",
  componentType: "PostureTrendWidget",
  description:
    "Trend analysis showing posture improvements over time with deployment milestones.",
  chartType: "two-line",
};

export function getAvailableWidgets(postureTrendWidget = false) {
  if (postureTrendWidget) {
    return [...AVAILABLE_WIDGETS, POSTURE_TREND_WIDGET_DEFINITION];
  }
  return AVAILABLE_WIDGETS;
}

// Default widgets to show on initial load
export const DEFAULT_WIDGETS = [AVAILABLE_WIDGETS[0], AVAILABLE_WIDGETS[1]];

// Grid layout configuration
export const GRID_CONFIG = {
  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols: { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
  rowHeight: 100,
  margin: [20, 20],
  containerPadding: [10, 10],
  draggableHandle: ".widgetHeaderTitle",
  resizeHandles: ["se"],
};
